import { useEffect, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { usePortal } from '../../contexts/PortalContext';
import { FORM_MODULES } from '../../lib/formModules';
import { PortalWebPushBanner } from '../notifications/PortalWebPushBanner';
import { PortalFloatingShell } from './PortalFloatingShell';
import { PortalPresenceReporter } from './PortalPresenceReporter';
import '../../styles/dem-theme-lab.css';

export function FormsAppShell() {
  const { basePath } = usePortal();

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('has-dock');
    root.style.removeProperty('--dock-clearance');
    root.style.removeProperty('--mobile-header-clearance');
    root.style.setProperty('--dock-clearance', '0px');
    root.style.setProperty('--mobile-header-clearance', '0px');
    return () => {
      root.style.removeProperty('--dock-clearance');
      root.style.removeProperty('--mobile-header-clearance');
    };
  }, []);

  const home = basePath || '/forms';

  const nav = useMemo(
    () => [
      {
        to: home,
        label: 'Home',
        icon: '🏠',
        end: true,
      },
      ...FORM_MODULES.map((mod) => ({
        to: basePath ? `${basePath}/${mod.slug}` : `/${mod.slug}`,
        label: mod.label,
        icon: mod.icon,
      })),
    ],
    [basePath, home],
  );

  return (
    <div className="app-shell app-shell--dock app-shell--forms app-shell--dem-theme-lab">
      <PortalPresenceReporter portal="forms" />
      <div className="main">
        <PortalWebPushBanner variant="toast" />
        <div className="page">
          <PortalFloatingShell portalName="Application Form" portalKind="forms" items={nav}>
            <Outlet />
          </PortalFloatingShell>
        </div>
      </div>
    </div>
  );
}
